import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {mainViewComponentEmpresa} from "./main-view-empresa.component";


@NgModule({
    declarations: [mainViewComponentEmpresa],
    imports     : [BrowserModule],
})

export class MainViewEmpresaModule {}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/main-view-empresa/main-view-empresa.module.ts